
// const baseURL = 'http://192.168.1.33:8097/cframework/'
// const resoursePhoto = 'http://localhost:8099/cframework/uploadFiles/photo'
// const uploadPhoto = 'http://localhost:8099/cframework/uploadFiles/photo'
// const photoPath = 'http://localhost:8099/cframework/uploadFiles/photo'

// const baseURL = 'http://zhiyuanshijie.sx-tech.net/zysj/'
// const resoursePhoto = 'http://zhiyuanshijie.sx-tech.net/zysj/uploadFiles/photo'
// const uploadPhoto = '/zysj/uploadFiles/photo'
// const photoPath = 'http://zhiyuanshijie.sx-tech.net/zysj/uploadFiles/photo'

const baseURL = 'http://zysj.zhiyuanshijie.com/'
const resoursePhoto = 'http://zysj.zhiyuanshijie.com/uploadFiles/photo'
const uploadPhoto = 'src="/uploadFiles/photo' // 需要换的路径
const photoPath = 'src="http://zysj.zhiyuanshijie.com/uploadFiles/photo' // 换成的路径

export default {
  baseURL,
  resoursePhoto,
  uploadPhoto,
  photoPath
}
